import React, { useEffect, useRef, useState } from "react";

export default function AnimatedTitle({
  children,
  as: Tag = "h1",
  className = "",
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`home-title ${visible ? "animate-in" : ""} ${className}`}
    >
      {children}
    </Tag>
  );
}